define('plugin/google-translate/view/GoogleTranslateModuleIndexView',['require','lib/view/LayoutView'],function (require) {


    var LayoutView = require('lib/view/LayoutView');

    // TranslateElement arrives with a second, lazily-fetched Google script, so it can still be
    // missing while google.translate itself exists (blocked by CSP, network failure, ...).
    // Without this check that becomes a hard TypeError -- reported live as "cannot read
    // properties of undefined (reading getInstance)", SCP Full Round 3.
    function isGoogleTranslateReady() {
        return typeof google !== 'undefined' && typeof google.translate !== 'undefined' && typeof google.translate.TranslateElement !== 'undefined';
    }

    /**
     * Google Translate Module composite view (images container)
     *
     * @class GoogleTranslateModuleIndexView
     */
    return LayoutView.extend({

        template: '#google_translate_module_view',
        googleUi : 'google_translate_element',

        modes : {},
        modelEvents:  {
            'sync': 'render',
        },

        googleInstance : null,

        initialize: function () {
           this.runGT = _.debounce(_.bind(this.runGT, this), 500, false);

            Backbone.Wreqr.radio.channel('page').vent.on(
                'shown', _.bind(this._onPageChanged, this)
            );
        },

        _onPageChanged : function(event){
            this._resetGTView();
        },

        onRender : function(){
            if (!isGoogleTranslateReady()) {
                return;
            }

            this.googleInstance = google.translate.TranslateElement.getInstance();

            if(jQuery("#" + this.googleUi).length && !this.googleInstance && this.model.get('id')) {
                this.runGT();
            }

            this._resetGTView();
        },

        runGT : function(opts){
            if (!isGoogleTranslateReady()) {
                return;
            }

            this.modes = {
                vertical: google.translate.TranslateElement.InlineLayout.VERTICAL,
                horizontal: google.translate.TranslateElement.InlineLayout.HORIZONTAL,
                select: google.translate.TranslateElement.InlineLayout.SIMPLE,
            };

            var options = {
                pageLanguage: this.model.get('base_lang'),
                layout: this.modes['vertical'],
                autoDisplay: false
            };

            if (this.model.get('langs')) {
                options['includedLanguages'] = this.model.get('langs');
            }

            // set vertical layout for small screens
            var screenWidth = window.innerWidth || document.documentElement.clientWidth;

            if (screenWidth < 1024) {
                options['layout'] = this.modes['vertical'];
            } else if (this.model.get('mode')) {
                options['layout'] = this.modes[this.model.get('mode')];
            }

            this.googleInstance = new google.translate.TranslateElement(options, this.googleUi);

            this._saveGTView();
        },

        _resetGTView : function(){
            if(!_.isUndefined(window['googleTranslateUI'])){
                jQuery("#" + this.googleUi).replaceWith(window['googleTranslateUI']);
            }
        },

        _saveGTView : function(){
            window['googleTranslateUI'] = jQuery("#" + this.googleUi);
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
                'module': 'google-translate'
            });
        }

    });

});
